import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  fetchStreamsListings,
  streamsListingsSelector,
} from '../../../LandingPage/LandingPage.duck';
import { useDispatch, useSelector } from 'react-redux';
import { CarouselSection, IconCollection } from '../../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { LISTING_TYPE_STREAM } from '../../../../constants';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
import { getListingEmptyCardData } from '../listingEmptyCardData';

const StreamsSection = ({ sectionName, description, currentUser }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const streamsListings = useSelector(streamsListingsSelector);

  useEffect(() => {
    dispatch(fetchStreamsListings());
  }, []);

  const showMoreSeries = () => {
    history.push(createResourceLocatorString('StreamsPage', routeConfiguration, {}));
  };

  const emptyCardData = getListingEmptyCardData({
    currentUser,
    listings: streamsListings,
    listingType: LISTING_TYPE_STREAM,
    icon: <IconCollection icon="icon-live-streams" />,
    intl,
    defaultTitleId: 'ListingEmptyCard.streamsTitle',
    defaultTextId: 'ListingEmptyCard.streamsText',
  });

  return streamsListings?.length ? (
    <CarouselSection
      name={sectionName}
      description={description}
      items={streamsListings}
      handleAction={showMoreSeries}
      emptyCardData={emptyCardData}
    />
  ) : null;
};

export default StreamsSection;
